module.exports = __webpack_public_path__ + "img/academy.5e773009.jpg";